import { connect } from "react-redux";

import AuthErrorPage from "./page";

export const AuthErrorPageContainer = connect()(AuthErrorPage);
